import { Directive, inject, input } from '@angular/core';
import { SectionNavigationService } from './section-navigation.service';

/** Link para uma seção da home: `<a appSectionLink="contato">`. Funciona também a partir de outras páginas. */
@Directive({
  selector: 'a[appSectionLink]',
  host: {
    '[attr.href]': "'/#' + appSectionLink()",
    '(click)': 'navigate($event)'
  }
})
export class SectionLinkDirective {
  private readonly navigation = inject(SectionNavigationService);

  readonly appSectionLink = input.required<string>();

  navigate(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) {
      return;
    }
    event.preventDefault();
    this.navigation.goTo(this.appSectionLink());
  }
}
